
import { Cell } from "../ListElements"
import { pick } from 'dot-object'
import NumericFilter from "./customSelectionFilter/NumericFilter/NumericFilter"
import StringFilter from "./customSelectionFilter/StringFilter/StringFilter"
import DateFilter from "./customSelectionFilter/DateFilter/DateFilter"
import SelectOptionsFilter from "./customSelectionFilter/SelectOptionsFilter/SelectOptionsFilter"
import ElementInListFilter from "./customSelectionFilter/SelectOptionsFilter/ElementInListFilter"
import { Icon } from "src/mtska-frontend-app-component/assets"

export const getDateOperators = (t) => {
    return [
        { value: 'between', label: t('between') },
        { value: 'before', label: t('before') },
        { value: 'after', label: t('after') }
    ]
};

export const getStringOperators = (t) => {
    return [
        { value: 'contains', label: t('contains') },
        { value: 'doesNotContain', label: t('doesNotContain') },
        { value: 'equals', label: t('equals') },
        { value: 'doesNotEqual', label: t('doesNotEqual') },
        { value: 'startsWith', label: t('startsWith') },
        { value: 'endsWith', label: t('endsWith') },
        { value: 'isEmpty', label: t('isEmpty') },
        { value: 'isNotEmpty', label: t('isNotEmpty') }
    ]
};

export const getSelectOperators = (t) => {
    return [
        { value: 'equals', label: t('equals') },
        { value: 'doesNotEqual', label: t('doesNotEqual') },
        { value: 'contains', label: t('contains') },
    ]
};

export const getBooleanOperators = (t) => {
    return [
        { value: 'equals', label: t('equals') },
        { value: 'doesNotEqual', label: t('doesNotEqual') }
    ]
};

export const getListOperators = (t) => {
    return [
        { value: 'isAnyOf', label: t('isAnyOf') },
        { value: 'notAnyOf', label: t('notAnyOf') }
    ]
};

export const getNumericOperators = (t) => {
    return [
        { value: '=', label: t('=') },
        { value: '>=', label: t('>=') },
        { value: '>', label: t('>') },
        { value: '<=', label: t('<=') },
        { value: '<', label: t('<') }
    ]
};

export const getCustomFilterOperators = ({ options, t, type, value }) => {
    switch (type) {
        case 'number':
        case 'currency':
        case 'integer':
        case 'float':
        case 'percentage':
        case 'scale_0_100':
            const numericOperators = getNumericOperators(t);
            return {
                filterOperators: numericOperators.map(op => ({
                    label: op.label,
                    value: op.value,
                    InputComponent: (params) => (
                        <NumericFilter {...params} value={value} />
                    )
                }))
            }
        case 'date':
        case 'datetime':
            const dateOperators = getDateOperators(t);
            return {
                filterOperators: dateOperators.map(op => ({
                    label: op.label,
                    value: op.value,
                    InputComponent: (params) => (
                        <DateFilter {...params} value={value} showOperatorChange />
                    )
                })),
            }
        case 'status':
        case 'translatable':
        case 'select':
        case 'commaseparated':
            const selectOperators = getSelectOperators(t);
            return {
                filterOperators: selectOperators.map(op => ({
                    label: op.label,
                    value: op.value,
                    InputComponent: (params) => (
                        <SelectOptionsFilter {...params} value={value} options={options} />
                    )
                })),
            }
        case 'boolean':
            const boolOperators = getBooleanOperators(t);
            return {
                filterOperators: boolOperators.map(op => ({
                    label: op.label,
                    value: op.value,
                    InputComponent: (params) => (
                        <SelectOptionsFilter {...params} value={value} options={options} />
                    )
                })),
            }
        // case 'genericList':
        //     const listOperators = getListOperators(t);
        //     return {
        //         filterOperators: listOperators.map(op => ({
        //             label: op.label,
        //             value: op.value,
        //             InputComponent: (params) => (
        //                 <ElementInListFilter {...params} value={value} options={options} />
        //             )
        //         })),
        //     }
        default:
            const stringOperators = getStringOperators(t);
            return {
                filterOperators: stringOperators.map(op => ({
                    label: op.label,
                    value: op.value,
                    InputComponent: (params) => (
                        <StringFilter {...params} value={value} />
                    )
                }))
            }
    }
}

export const getOperatorsByType = (t, type) => {
    switch (type) {
        case 'number':
        case 'integer':
        case 'float':
        case 'currency':
        case 'percentage':
            return getNumericOperators(t);
        case 'date':
        case 'datetime':
            return getDateOperators(t);
        case 'status':
        case 'translatable':
        case 'select':
            //case '':
            return getSelectOperators(t);
        case 'boolean':
            return getBooleanOperators(t);
        default:
            return getStringOperators(t);
    }
}

export const getCustomLocaleText = ({ t }) => {
    return {
        headerFilterOperatorBetween: t('Between'),
        headerFilterOperatorContains: t('Contains'),
        headerFilterOperatorDoesNotContain: t('Does not contain'),
        headerFilterOperatorEquals: t('Equals'),
        headerFilterOperatorDoesNotEqual: t('Does not equal'),
        headerFilterOperatorStartsWith: t('Starts with'),
        headerFilterOperatorEndsWith: t('Ends with'),
        headerFilterOperatorIs: t('Is'),
        headerFilterOperatorNot: t('Is not'),
        headerFilterOperatorIsNot: t('Is not'),
        headerFilterOperatorAfter: t('Is after'),
        headerFilterOperatorOnOrAfter: t('Is on or after'),
        headerFilterOperatorAfterOrNull: t('After or null'),
        headerFilterOperatorBefore: t('Is before'),
        headerFilterOperatorOnOrBefore: t('Is on or before'),
        headerFilterOperatorBeforeOrNull: t('Before or null'),
        headerFilterOperatorIsEmpty: t('Is empty'),
        headerFilterOperatorIsNotEmpty: t('Is not empty'),
        headerFilterOperatorIsAnyOf: t('Is any of'),
        headerFilterOperatorSelectFilter: t('Select Filter'),
        headerFilterOperatorIn: t('In'),
        'headerFilterOperator=': t('Equals'),
        'headerFilterOperator!=': t('Not equals'),
        'headerFilterOperator>': t('Greater than'),
        'headerFilterOperator>=': t('Greater than or equal to'),
        'headerFilterOperator<': t('Less than'),
        'headerFilterOperator<=': t('Less than or equal to'),
        // ----
        filterOperatorBetween: t('Between'),
        filterOperatorAfter: t('After'),
        filterOperatorBefore: t('Before'),
        filterOperatorEquals: t('Equals'),
        filterOperatorNotEquals: t('Not equals'),
    }
}

export const getFormattedRows = ({ items, tableConfig }) => {
    const { columnsRendered = {} } = tableConfig
    const formattedRows = (items || []).map((item = {}) => {
        const formattedItem = {}
        Object.keys(item).forEach((key) => {
            const { [key]: value } = item
            const type = columnsRendered[key]?.type
            if (type === 'date' || type === 'datetime') {
                formattedItem[key] = value ? new Date(value) : undefined
            } else {
                formattedItem[key] = value
            }
        })
        return formattedItem
    })
    return formattedRows
}

export const getVirtualScrollerHeight = (apiRef, rows, expansionModel) => {
    const density = apiRef.current.state.density; // 'compact' | 'standard' | 'comfortable'

    const densityHeights = {
        compact: 32,
        standard: 52,
        comfortable: 72
    };

    const rowHeightByDensity = densityHeights[density];
    const parentRows = (rows ?? []).filter(r => r.hierarchy.length === 1).length;
    const expandedChildren = Object.entries(expansionModel).filter(([id, isExpanded]) => isExpanded).length;
    const totalVisibleRows = parentRows + expandedChildren;
    const correctHeight = totalVisibleRows * rowHeightByDensity;

    return correctHeight;
}

export const moveArrayElement = (array, fromIndex, toIndex) => {
    const element = array[fromIndex]
    array.splice(fromIndex, 1)
    array.splice(toIndex, 0, element)
    return array
}

export const handleApplyRecipe = (recipe, apiRef, setSettingsKey) => {
    if (!recipe) return;

    // NON PRENDERE DA QUI LE COLONNE; PRENDILE DA 
    // const { tableConfig } = config?.data?.modules[dataProviderName];
    const ac = apiRef.current.getAllColumns();

    const vm = Object.fromEntries(
        ac.map((c) => {
            if (recipe[c.field]) {
                return [c.field, true];
            }

            return [c.field, false];
        })
    );

    setSettingsKey('visibilityModel', vm);
}

export const getColumnRender = (settings, config, dataProviderName, localFilterModel, t, detailStack, processRowUpdate) => {
    if (!settings || !config?.data?.modules[dataProviderName]?.tableConfig) return;
    const { tableConfig } = config?.data?.modules[dataProviderName];

    if (Array.isArray(tableConfig?.columns) && Object.keys(settings).length > 0) {
        const { visibilityModel } = settings;
        const columns = tableConfig.columns.map((field) => getSingleColumn(field, dataProviderName, tableConfig, visibilityModel, localFilterModel, t, detailStack, processRowUpdate))
        return columns
    }
}

export const getSingleColumn = (field, dataProviderName, tableConfig, visibilityModel, localFilterModel, t, detailStack, processRowUpdate) => {

    const {
        editable,
        fieldKey,
        options: valueOptions,
        optionsEditable = {},
        type: fieldType,
        typeEditable
    } = tableConfig.columnsRendered[field] || {}

    const {
        action,
        dataProviderName: optionsDataProviderName,
        filters,
        optionKey,
        optionLabel
    } = optionsEditable

    // campi filtri custom

    const { items = [] } = localFilterModel || {}
    const value = items.find(item => item.field === field)?.value;

    const customFilterOperators = getCustomFilterOperators({ options: valueOptions, t, type: fieldType, value });

    // campi celle custom
    const isCustomField = [/*'boolean' , 'currency' */, 'relationship'].includes(fieldType)
    //const minWidth = ['date', 'datetime'].includes(fieldType) || ['relationship'].includes(typeEditable) ? 220 : 150

    const minWidthDefault = ['date', 'datetime'].includes(fieldType) || ['relationship'].includes(typeEditable) ? 220 : 150
    const minWidthPref = tableConfig.columnsRendered[field]?.minWidth ? tableConfig.columnsRendered[field]?.minWidth : minWidthDefault;

    const maxWidthDefault = 'auto';
    const maxWidthPref = tableConfig.columnsRendered[field]?.maxWidth ? tableConfig.columnsRendered[field]?.maxWidth : maxWidthDefault;
    //console.info('larghezza', field, minWidthPref, maxWidthPref, minWidthDefault)

    const filterType = isCustomField
        ? undefined
        : valueOptions
            ? 'singleSelect'
            : fieldType === 'date' || fieldType === 'datetime'
                ? fieldType
                : fieldType === 'currency'
                    ? 'number'
                    : 'string'

    let iconicprops = {};
    if (tableConfig.columnsRendered[field]?.icon) {
        iconicprops = {
            minWidth: 60,
            headerName: '',
            renderHeader: () => (
                <Icon icon={tableConfig.columnsRendered[field]?.icon} aria-label={field} title={field} />
            ),
            headerClassName: 'mtska-iconic-column'
        }
    }

    return {
        editable: typeEditable ? false : editable,
        field,
        flex: 1,
        headerName: tableConfig.columnsRendered[field]?.label ?? t(field.replace("_readable", "")
            .replace("_calculated_", "")
            .replace("_related_", "")
            .replace("_related.", "")),
        hideable: visibilityModel === false || tableConfig.columnsRendered[field]?.hideable === false ? false : true,
        filterable: tableConfig.columnsRendered[field]?.filterable === false ? false : true,
        sortable: tableConfig.columnsRendered[field]?.sortable === false ? false : true,
        minWidth: minWidthPref,
        //maxWidth: maxWidthPref,
        renderCell: (params) => {
            const columnRendered = tableConfig.columnsRendered[params?.field]
            const drawerRoute = tableConfig.columnsRendered[params?.field]?.drawerRoute
            const fieldDataProviderName = tableConfig.columnsRendered[params?.field]?.providerName;
            const val = typeof params?.row === 'object' ? pick(field, params.row) : params.value?.value;
            return (
                <Cell
                    action={action}
                    columnRendered={columnRendered}
                    configFilters={filters}
                    fieldKey={fieldKey}
                    dataProviderName={dataProviderName}
                    detailStack={detailStack}
                    drawerRoute={drawerRoute}
                    field={params?.field}
                    fieldDataProviderName={fieldDataProviderName}
                    filters={filters}
                    optionKey={optionKey}
                    optionLabel={optionLabel}
                    optionsDataProviderName={optionsDataProviderName}
                    processRowUpdate={processRowUpdate}
                    row={params.row}
                    type={columnRendered?.type}
                    typeEditable={typeEditable}
                    value={val}
                    valueOptions={valueOptions}
                />
            )
        },
        type: filterType,
        valueOptions,

        ...customFilterOperators,
        ...iconicprops
    }
}



export const getColumnDefinition = (settings, config, dataProviderName, t) => {
    if (!settings || !config?.data?.modules[dataProviderName]?.tableConfig) return;

    const { tableConfig } = config?.data?.modules[dataProviderName];

    if (Array.isArray(tableConfig?.columns) && Object.keys(settings).length > 0) {

        const { filterModel, visibilityModel } = settings;
        const { items = [] } = filterModel || {}

        // if (items.length > 0) {
        //     const cleanFilterModel = cleanFilters(filterModel);
        //     managePotentiallyChangedFilters(cleanFilterModel, false);
        // }

        const columns = tableConfig.columns.map((field) => {
            const {
                fieldKey,
                options: valueOptions,
                optionsEditable = {},
                type: fieldType,
                typeEditable,
                hideable
            } = tableConfig.columnsRendered[field] || {}

            const {
                action,
                dataProviderName: optionsDataProviderName,
                filters,
                optionKey,
                optionLabel
            } = optionsEditable

            // campi filtri custom
            const value = items.find(item => item.field === field)?.value;
            let customFilterOperators = {}
            if (valueOptions || ['date', 'datetime'].includes(fieldType)) {
                customFilterOperators = getCustomFilterOperators({ options: valueOptions, t, type: fieldType, value })
            }

            // campi celle custom
            const isCustomField = [/* 'boolean', 'currency' */, 'relationship'].includes(fieldType)
            const minWidth = ['date', 'datetime'].includes(fieldType) || ['relationship'].includes(typeEditable) ? 220 : 150
            const filterType = isCustomField
                ? undefined
                : valueOptions
                    ? 'singleSelect'
                    : fieldType === 'date' || fieldType === 'datetime'
                        ? fieldType
                        : fieldType === 'currency'
                            ? 'number'
                            : 'string'


            return {
                field,
                fieldKey,
                value,
                type: fieldType,
                typeEditable,

                options: valueOptions,
                action,
                dataProviderName: optionsDataProviderName,
                filters,
                optionKey,
                optionLabel,

                ...customFilterOperators,
                isCustomField,
                hideable,
                filterType
            }
        })

        return columns
    }
}